import { Head_3 } from '../Typography';
import HeaderPages from '../HeaderPages';
import styled from 'styled-components';
import Form from './form';
const FormContact = () => {
  return (
    <FormContactContainer>
      <HeaderPages title="Contact Me" shadow={'Me'} />
      <Head_3>I Am Available For Freelance</Head_3>
      <Form />
    </FormContactContainer>
  );
};

const FormContactContainer = styled.div`
  width: 100%;
  padding-left: 5rem;
  padding-top: 7rem;
`;

export default FormContact;
